// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__XQUzD","main":"Partners_main__cNkq5","text":"Partners_text__pfTXe","allPartners":"Partners_allPartners__zKUcb","partner":"Partners_partner__PYeZP"};